import './style.css'
// script.js - KEEP this import
import Experience from './Experience/Experience.js'

// Use a slight modification to avoid the unused variable warning
new Experience(document.querySelector('canvas.webgl'))